export enum FilterFlow {
  INCLUDE = 'include',
  EXCLUDE = 'exclude',
}
